<template>
    <div class="slider" v-if="images.length > 0">
        <div class="slider__images">
            <img
                :alt="`${inx}-${title}`"
                :class="{ active: current === inx }"
                :key="inx"
                :src="url + out.image"
                v-for="(out, inx) in images"
            />
        </div>
        <button @click="currentImage('prev')" class="slider__button" type="button" v-if="images.length > 1">
            <v-icon name="arrow-dropleft" />
        </button>
        <button @click="currentImage('next')" class="slider__button" type="button" v-if="images.length > 1">
            <v-icon name="arrow-dropright" />
        </button>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        images: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            current: 0,
            url: 'https://images.mapaprop.app/photos/',
        }
    },
    methods: {
        currentImage(position) {
            if (position === 'prev') {
                if (this.current == 0) {
                    this.current = this.images.length - 1
                } else {
                    this.current--
                }
            }
            if (position === 'next') {
                if (this.current == this.images.length - 1) {
                    this.current = 0
                } else {
                    this.current++
                }
            }
        },
    },
}
</script>

<style lang="scss">
.slider {
    position: relative;
    transition: all 0.5s;
    border-bottom: 1px solid #e3e3e3;
    background-color: #ffffff;
    &__images {
        position: relative;
        height: 400px;
        img {
            position: absolute;
            z-index: 1;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            height: calc(100% - 1rem);
            width: 100%;
            object-fit: contain;
            visibility: hidden;
            opacity: 0;
            transition: visibility 0.5s, opacity 0.5s;
            &.active {
                z-index: 2;
                visibility: visible;
                opacity: 1;
            }
        }
    }

    &__button {
        position: absolute;
        z-index: 3;
        top: 50%;
        transform: translateY(-50%);
        height: 40px;
        width: 40px;
        border-radius: 50%;
        background-color: #ffffff;
        box-shadow: 0 0 4px 0 rgba(#000000, 0.2);
        svg {
            height: 30px;
            width: 30px;
            opacity: 0.5;
            fill: #c9d700;
        }
        &:hover {
            svg {
                opacity: 1;
            }
        }
        &:nth-of-type(1) {
            left: 1rem;
        }
        &:nth-of-type(2) {
            right: 1rem;
        }
    }
    &:hover {
        background-color: #f3f3f3;
    }
    @media (max-width: 992px) {
        &__images {
            height: 300px;
        }
    }
    @media (max-width: 576px) {
        &__images {
            height: 200px;
        }
    }
}
</style>
